import styled from 'styled-components/macro';
import { TABLET_BREAKPOINT } from '../../app/constants';

export const APP_WIDTH = '1440px';

export const Container = styled.div`
`;


export const Main = styled.div`
  flex-grow: 1;
  display: flex;
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: block;
    max-height: none;
  }
  .sponsors-mobile {
    display: none;
    @media (max-width: ${TABLET_BREAKPOINT}px) {
      display: block;
    }
  }
`;

export const MainContent = styled.div`
  align-items: flex-start;
  flex-direction: column;
  display: flex;
  width: 0;
  flex-grow: 1;
  @media (max-width: ${TABLET_BREAKPOINT}px) {
    display: block;
    width: 100%;
  }
`;

export const MainContentBody = styled.div`
  width: 100%;
  height: 100%;
`;

export const AppContainer = styled.div`
  max-width: ${APP_WIDTH};
  margin: 0 auto;
  position: relative;
`;

